import type { ReactNode } from "react";
import tipIcon from "@/assets/tipIcon.svg";
import importantIcon from "@/assets/importantIcon.svg";
import fyiIcon from "@/assets/fyiIcon.svg";
import type { CalloutType } from "./type";

import * as styles from "./Callout.styles";

type CalloutProps = {
  type: CalloutType;
  children: ReactNode;
};

const iconMap = {
  tip: tipIcon,
  important: importantIcon,
  fyi: fyiIcon,
};

const Callout = ({ type, children }: CalloutProps) => {
  const icon = iconMap[type];
  return (
    <div css={styles.callout(type)} role="note" aria-label={`${type} callout`}>
      <div css={styles.iconContainer}>
        <img src={icon} alt={type} />
      </div>
      <div css={styles.content}>
        <h5 css={styles.title(type)}>{type}</h5>
        <div>{children}</div>
      </div>
    </div>
  );
};

export { Callout };
